export default "/dist/files/icon_coffre_fort_gris.7981b22a93ffef52b9075f2d6035e5d7.svg";